/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const GET_PASSWORD_POLICIES_START = 'GET_PASSWORD_POLICIES_START';
export const GET_PASSWORD_POLICIES_SUCCESS = 'GET_PASSWORD_POLICIES_SUCCESS';
export const GET_PASSWORD_POLICIES_FAILURE = 'GET_PASSWORD_POLICIES_FAILURE';
export const GET_PASSWORD_POLICY_DETAILS_START = 'GET_PASSWORD_POLICY_DETAILS_START';
export const GET_PASSWORD_POLICY_DETAILS_SUCCESS = 'GET_PASSWORD_POLICY_DETAILS_SUCCESS';
export const GET_PASSWORD_POLICY_DETAILS_FAILURE = 'GET_PASSWORD_POLICY_DETAILS_FAILURE';
export const GET_PASSWORD_POLICIES_RULE_START = 'GET_PASSWORD_POLICIES_RULE_START';
export const GET_PASSWORD_POLICIES_RULE_SUCCESS = 'GET_PASSWORD_POLICIES_RULE_SUCCESS';
export const GET_PASSWORD_POLICIES_RULE_FAILURE = 'GET_PASSWORD_POLICIES_RULE_FAILURE';
export const FETCH_UPDATE_DATA_FORM_VALUES = 'FETCH_UPDATE_DATA_FORM_VALUES';